import Agenda from "beaktDay/views/AdminAgenda/Agenda/Agenda.js";
import GestaoAgenda from "beaktDay/views/AdminAgenda/Agenda/GestaoAgenda.js";
import ProfissionalList from "beaktDay/views/AdminAgenda/Cadastros/ProfissionalList.js";
import ExpedienteList from "beaktDay/views/AdminAgenda/Cadastros/ExpedienteList.js";
import EspecialidadeList from "beaktShared/views/Cadastros/EspecialidadeList.js";
import ServicoList from "beaktShared/views/Cadastros/ServicoList.js";
import GestaoClienteList from "beaktDay/views/AdminAgenda/Clientes/GestaoClienteList.js";
import Estabelecimento from "beaktDay/views/AdminAgenda/Outros/Estabelecimento.js";
import Dashboard from "beaktDay/views/AdminAgenda/Dashboard/Dashboard.js";
import LoginPage from "beaktShared/views/GenericPages/LoginPage.js";
import HomePage from "beaktDay/views/PortalAgenda/HomePage.js";
import PricingPage from "beaktDay/views/PortalAgenda/PricingPage.js";
import RegisterPage from "beaktDay/views/PortalAgenda/RegisterPage.js";
import NewPage from "beaktShared/views/GenericPages/NewPage.js";
import UserProfile from "beaktShared/views/GenericPages/UserProfile.js";
import AccessDenied from "beaktShared/views/Seguranca/AcessoNegado.js";
import BloqueioAgenda from "beaktDay/views/AdminAgenda/Agenda/BloqueioAgenda.js";

// @material-ui/icons
import DateRange from "@material-ui/icons/DateRange";
import People from "@material-ui/icons/People";
import Assignment from "@material-ui/icons/Assignment";
import Face from "@material-ui/icons/Face";
import CalendarToday from "@material-ui/icons/CalendarToday";
import InsertChart from "@material-ui/icons/InsertChart";
import CalendarViewDay from "@material-ui/icons/CalendarViewDay";
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import TimerOffIcon from '@material-ui/icons/TimerOff';

var dashRoutes = [
  {
    path: "/agenda",
    name: "agenda",
    mini: "AG",
    icon: CalendarToday,
    component: Agenda,
    layout: "/adminday",
    showmenu: true
  },
  {
    path: "/gestaoagenda",
    name: "agenda_management",
    mini: "GA",
    icon: CalendarViewDay,
    component: GestaoAgenda,
    layout: "/adminday",
    showmenu: true
  },  
  {
    path: "/dashboardagenda",
    name: "dashboard",
    mini: "DA",
    icon: InsertChart,
    component: Dashboard,
    layout: "/adminday",
    showmenu: true
  },
  {
    path: "/pesquisasatisfacaoagenda",
    name: "clients",
    icon: People,
    component: GestaoClienteList,
    layout: "/adminday",
    showmenu: true
  },
  {
    path: "/gestaoclientes",
    name: "Pesquisa de Satisfação",
    icon: People,
    component: NewPage,
    layout: "/adminday",
    showmenu: false
  }, 
  {
    collapse: true,
    name: "professional",
    icon: DateRange,
    state: "profissionaisCollapse",
    views: [
      {
        path: "/cadastroprofissional",
        name: "professional_register",
        mini: "CP",
        component: ProfissionalList,
        layout: "/adminday",
        showmenu: true
      },
      {
        path: "/cadastroexpediente",
        name: "expedients_register",
        mini: "CE",
        component: ExpedienteList,
        layout: "/adminday",
        showmenu: true
      }
    ]
  },  
  {
    collapse: true,
    name: "settings",
    icon: Assignment,
    state: "configCollapse",
    views: [
      {
        path: "/cadastroespecialidade",
        name: "specialty_register",
        mini: "CE",
        component: EspecialidadeList,
        layout: "/adminday",
        showmenu: true
      },
      {
        path: "/cadastroservico",
        name: "service_register",
        mini: "CS",
        component: ServicoList,
        layout: "/adminday",
        showmenu: true
      },
      {
        path: "/estabelecimentoagenda",
        name: "establishment",
        mini: "ES",
        component: Estabelecimento,
        layout: "/adminday",
        showmenu: true
      },
      {
        path: "/bloqueioagenda",
        name: "calendar_lock",
        mini: "BA",    
        component: BloqueioAgenda,
        layout: "/adminday",
        showmenu: true
      },
    ]
  },
  {
    path: "/user",
    name: "profile",
    mini: "MP",
    icon: Face,
    component: UserProfile,
    layout: "/adminday",
    showmenu: false
  },
  {
    path: "/pricing",
    name: "Planos",
    mini: "PP",
    component: PricingPage,
    layout: "/institutionalday",
    showmenu: false
  },
  {
    path: "/login",
    name: "Login",
    mini: "L",
    component: LoginPage,
    layout: "/institutionalday",
    showmenu: false
  },
  {
    path: "/home",
    name: "home",
    mini: "HO",
    component: HomePage,
    layout: "/institutionalday",
    showmenu: false
  },
  {
    path: "/register",
    name: "Cadastro",
    mini: "RG",
    component: RegisterPage,
    layout: "/institutionalday",
    showmenu: false
  },
  {
    path: "/accessdenied",
    name: "Acesso Negado",
    icon: VerifiedUserIcon,
    component: AccessDenied,
    layout: "/adminday",
    showmenu: false
  }
];
export default dashRoutes;
